<template>
	<span
		class="base-badge"
		:class="[`base-badge--${variant}`, `base-badge--${size}`, { 'base-badge--pill': pill }]"
	>
		<slot />
	</span>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
	name: 'BaseBadge',

	props: {
		variant: {
			type: String,
			default: 'default',
			validator: (value: string) =>
				[
					'default',
					'primary',
					'secondary',
					'success',
					'danger',
					'warning',
					'info',
					'light',
					'dark',
				].includes(value),
		},
		size: {
			type: String,
			default: 'md',
			validator: (value: string) => ['sm', 'md', 'lg'].includes(value),
		},
		pill: {
			type: Boolean,
			default: false,
		},
	},
});
</script>

<style lang="scss" scoped>
.base-badge {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	font-weight: 500;
	text-align: center;
	vertical-align: baseline;
	white-space: nowrap;
	transition: all 0.15s ease-in-out;
	border-radius: 0.375rem;

	// Sizes
	&--sm {
		padding: 0.25rem 0.5rem;
		font-size: 0.75rem;
		line-height: 1;
	}

	&--md {
		padding: 0.375rem 0.75rem;
		font-size: 0.875rem;
		line-height: 1.25;
	}

	&--lg {
		padding: 0.5rem 1rem;
		font-size: 1rem;
		line-height: 1.5;
	}

	// Pill shape
	&--pill {
		border-radius: 50rem;
	}

	// Variants
	&--default {
		color: #495057;
		border: 1px solid #dee2e6;
		background-color: #f8f9fa;
	}

	&--primary {
		color: #fff;
		background-color: #007bff;
	}

	&--secondary {
		color: #fff;
		background-color: #6c757d;
	}

	&--success {
		color: #fff;
		background-color: #28a745;
	}

	&--danger {
		color: #fff;
		background-color: #dc3545;
	}

	&--warning {
		color: #212529;
		background-color: #ffc107;
	}

	&--info {
		color: #fff;
		background-color: #17a2b8;
	}

	&--light {
		color: #495057;
		border: 1px solid #dee2e6;
		background-color: #f8f9fa;
	}

	&--dark {
		color: #fff;
		background-color: #343a40;
	}
}
</style>
